import {put,takeLatest,call} from 'redux-saga/effects'
import * as venueService from "../../../services/venueService"
import {
    SET_SELECTED_VENUE,
    SET_SELECTED_VENUE_SUCCESS,
    SET_SELECTED_VENUE_ERROR
}
    from "../../actions/venue"

function* setSelectedVenueSaga(action) {
    try {
        let data={}
        
        if(action.payload.term)
            data=yield call(venueService.SearchVenue,action.payload)
        
        yield put({
            type: SET_SELECTED_VENUE_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: SET_SELECTED_VENUE_ERROR,error: error.data
        })
    }
}


export function* setSelectedVenueSagaWatcher() {
    yield takeLatest(SET_SELECTED_VENUE,setSelectedVenueSaga)
}